import {SingleParameter} from './single-parameter';
import {jsonArrayMember, jsonMember, jsonObject} from 'typedjson';

@jsonObject
export class MultipleParameter {
    @jsonMember
    name: string;
    @jsonArrayMember(MultipleParameter)
    multipleParameters: MultipleParameter[];
    @jsonArrayMember(SingleParameter)
    singleParameters: SingleParameter[];

    getSingleParameter(name: string): SingleParameter {
        return this.singleParameters.find(x => x.name === name);
    }

    getMultipleParameter(name: string): MultipleParameter {
        return this.multipleParameters.find(x => x.name === name);
    }
    getMultipleParameters(name: string): MultipleParameter[] {
        if (this.multipleParameters === undefined) {
            return [];
        }
        return this.multipleParameters.filter((x) => {
            return x.name === name ? true : false;
        });
    }
}
